import React from 'react';
import ComicaProV3 from './editor/ComicaProV3';

/**
 * ComicaCreator Wrapper
 * Updated to point to V3 editor (ComicaProV3) — the latest with:
 *   - Phase 1 brush engine (hardness, flow, stabilizer, scatter)
 *   - Touch pressure simulation & Apple Pencil support
 *   - Triple-tap pie menu gesture
 *   - Direct-DOM pie menu drag (no lag)
 *   - Fully responsive toolbar & layers panel
 */
const ComicaCreator = (props) => {
  return <ComicaProV3 mode="full" {...props} />;
};

export default ComicaCreator;
